/* Progressive-disclosure FAQ: only the first N rows show by default; the button toggles
   between showing all of them and collapsing back to that first N (see product-faq.liquid
   for the row-hiding CSS and the button's two label spans / arrow icon). */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-product-faq-toggle]');
  if (!button) return;

  const wrapper = button.closest('[data-product-faq]');
  if (!wrapper) return;

  const expanded = wrapper.hasAttribute('data-expanded');
  wrapper.toggleAttribute('data-expanded', !expanded);
  button.setAttribute('aria-expanded', String(!expanded));

  if (expanded) {
    // Collapsing back — scroll the button into view so the user isn't left staring
    // at whatever question used to be lower on the page.
    button.scrollIntoView({ block: 'nearest' });
  }
});
